/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  beneInternalDeniedApproval,
  editInternal,
  viewInternalAccountDetail,
} from "../../../../redux/features/internalApi/internalApi";

import { Box, Tooltip, tooltipClasses } from "@mui/material";
import { toast } from "react-toastify";
import TEXT from "../../../../../src/utils/globalText";
import ICONS from "../../../../assets/Icons/index.js";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import AdditionalRecipient from "../../../../components/AdditionalRecipient";
import FullScreen from "../../../../components/FullScreen";
import Loader from "../../../../components/Loader/Index";
import useServiceChecker from "../../../../components/ServiceChecker";
import { beneBankLookUp } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  addInternalAccLabel,
  removeInternalAccLabel,
} from "../../../../redux/features/InternalAccount/internalAccount";
import { beneInternalWaitingApproved } from "../../../../redux/features/internalApi/internalApi";
import { internalTxnMultiRejectApproval } from "../../../../redux/features/internalTransaction/internalTransactionSingleApproval";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { ownerListViewAllAcc } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { schedulesInternalTxnReject } from "../../../../redux/features/scheduleInternalTxn";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import InternalTransactionViewAll from "../../../InternalTransactionMain/InternalTransactionViewAll";
import ScheduleInternalTransactionViewSchedule from "../../../ScheduleInternalTransaction/ScheduleInternalTransactionViewSchedule";
import GSTVerification from "../../../Settings/GSTDetails";
import PanVerification from "../../../Settings/PanVerification";
import OwnerAccountIFSC from "../../OwnerAccount/OwnerAccountIFSC";
import InternalAccountViewAll from "../InternalAccountViewAll/index.jsx";
import "./index.css";

const InternalAccDetail = (payload) => {
  const [ensureAll] = useServiceChecker();
  const dispatch = useDispatch();
  const { id } = useParams();
  const resolvedAccountId =
    payload?.type === "bene_account_detail_modal"
      ? payload?.bene_account_id
      : id;
  const navigate = useNavigate();
  const labelActionDispatchedRef = useRef(false);
  const hasFetchedOwner = useRef(false);

  //useState
  const [errorStrip, setErrorStrip] = useState("");

  //useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const { viewInternalAccountDetailLoading, viewInternalAccountDetailData } =
    useSelector((state) => state.internalAcc);

  const { internalTxnViewAllAccData, internalTxnViewAllAccLoading } =
    useSelector((state) => state?.internalTxnViewall);

  const {
    schedulesInternalTxnViewAllData,
    schedulesInternalTxnViewAllLoading,
  } = useSelector((state) => state?.scheduleInternalTxnSlice);
  //useState
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [labelDetailTab, setLabelDetailTab] = useState(false);
  const [detailTab, setDetailTab] = useState(true);
  const [declineType, setdeclineType] = useState("");
  const [associateType, setAssociateType] = useState("");
  const [loading, setLoading] = useState(true);
  const [viewIntData, setViewIntData] = useState([]);
  const [rejectFlowType, setRejectFlowType] = useState("");
  const [openTxnHistory, setOpenTxnHistory] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [openInternalAssociate, setOpenInternalAssociate] = useState(false);
  const [showDeclinePopup, setShowDeclinePopup] = useState(false);
  const [owneraccountId, setOwnerAccountId] = useState("");
  const [deniedId, setDeniedId] = useState(null);
  const [clickedBtn, setClickedBtn] = useState(null);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);

  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [activeType, setActiveType] = useState("pan");

  const [labels, setLabels] = useState([]);
  const [editPopUp, setEditPopUp] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category: "",
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [additionalRecipient, setAdditionalRecipicent] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const { beneInternalDeniedApprovalLoading } = useSelector(
    (state) => state.internalAcc,
  );

  const [index, setIndex] = useState(
    detailTab
      ? GlobalConfiguration?.lengthCheckZero
      : labelDetailTab
        ? GlobalConfiguration?.lengthCheckOne
        : additionalRecipient
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useLayoutEffect(() => {
    setLoading(true);
  }, [resolvedAccountId]);

  const handleInputChange = (event) => {
    const value = event.target.value?.replace(/\s+/g, " ").trimStart() || "";

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    if (sanitizedValue.length <= GlobalConfiguration.inputMaxLength) {
      setDeclineReason(sanitizedValue);
    }
  };

  useEffect(() => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      return;
    }

    const bankAccNo =
      viewInternalAccountDetailData?.internal_accounts?.[0]?.bank_acc_no;
    const panNo = viewInternalAccountDetailData?.internal_accounts?.[0]?.pan_no;
    const ifscCode =
      viewInternalAccountDetailData?.internal_accounts?.[0]?.ifsc_code;

    if (!bankAccNo || !panNo || !ifscCode) return;

    if (hasFetchedOwner.current) return;
    hasFetchedOwner.current = true;

    const fetchOwnerID = async () => {
      if (ensureAll(["VAccount"]).status) {
        const data = await dispatch(
          ownerListViewAllAcc({
            bank_account_no: bankAccNo,
            pan: panNo,
            ifsc: ifscCode,
          }),
        );
        setOwnerAccountId(data?.payload?.owner_accounts?.[0]?.id);
      }
    };

    fetchOwnerID();
    setViewIntData(viewInternalAccountDetailData?.internal_accounts);
  }, [
    viewInternalAccountDetailData,
    viewInternalAccountDetailData?.internal_accounts?.[0]?.bank_acc_no,
    viewInternalAccountDetailData?.internal_accounts?.[0]?.pan_no,
    viewInternalAccountDetailData?.internal_accounts?.[0]?.ifsc_code,
  ]);
  useEffect(() => {
    if (
      viewInternalAccountDetailData &&
      viewInternalAccountDetailData.internal_accounts &&
      viewInternalAccountDetailData.internal_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const { bank_name, bank_acc_no, category, ifsc_code, id, pan_no, name } =
        viewInternalAccountDetailData.internal_accounts[0];
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [viewInternalAccountDetailData]);

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabelsInternal");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [viewInternalAccountDetailData?.internal_accounts?.[0]?.labels]);

  //function

  const toggleDetails = () => {
    setDetailTab(true);
    setLabelDetailTab(false);
    setAdditionalRecipicent(false);
  };

  const toggleLabelDetails = () => {
    setLabelDetailTab(true);
    setDetailTab(false);
    setAdditionalRecipicent(false);
  };
  const toggleAdditionalRecipicent = () => {
    setAdditionalRecipicent(true);
    setLabelDetailTab(false);
    setDetailTab(false);
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handleApprovalDetails = async (id) => {
    setShowLoader(true);

    UniversalRefreshToast("approvalaccountsRefresh");

    let response = await dispatch(beneInternalWaitingApproved(id));

    toast.dismiss();
    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "IAAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      setShowLoader(false);
      let error_msg = "";
      if (response?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.internal_account?.[0]) {
        error_msg = response.payload.errors.internal_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "Internal account already approved") {
        await dispatch(viewInternalAccountDetail({ id: resolvedAccountId }));
      } else {
      }
      try {
        const err_msg = error_msg;
        const updatedAccounts =
          response?.payload?.internal_accounts ||
          viewInternalAccountDetailData?.internal_accounts ||
          [];
        if (updatedAccounts.length === GlobalConfiguration.lengthCheckZero) {
          setViewIntData([
            {
              ...(viewInternalAccountDetailData?.internal_accounts?.[
                GlobalConfiguration.lengthCheckZero
              ] || {}),
              error_msg: err_msg,
            },
          ]);
        } else {
          if (!updatedAccounts[GlobalConfiguration.lengthCheckZero].error_msg)
            updatedAccounts[GlobalConfiguration.lengthCheckZero].error_msg =
              err_msg;
          setViewIntData(updatedAccounts);
        }
      } catch (e) {}
      toast.dismiss();
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } else {
      setViewIntData(response?.payload?.internal_accounts || []);
      setShowLoader(false);

      const successMessage = "Internal account approved successfully.";
      toast.dismiss();
      CommonToast({
        text: successMessage,
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
      });
      if (payload?.type === "bene_account_detail_modal") {
        setTimeout(() => {
          payload?.closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraLarger);
        setTimeout(() => {
          navigate("/internal_account_dashboard/internal_account_approval");
        }, IntervalConfiguration.intervalPopup);
      }
    }
  };

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  const handleDeclinedDetials = (id) => {
    setClickedBtn("reject");
    setShowDeclinePopup(true);
    setDeniedId(id);
    setRejectFlowType("rejectAccount");
  };

  const createIntTransaction = () => {
    if (
      services?.find(
        (service) => service === "CInternalTxn" || service === "Admin",
      ) !== undefined &&
      currentAccountDetails?.category?.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/internal_transaction_dashboard/create_internal_transaction", {
        state: currentAccountDetails,
      });
    } else if (
      services?.find(
        (service) => service === "CInternalTxn" || service === "Admin",
      ) !== undefined &&
      currentAccountDetails.category.length <=
        GlobalConfiguration?.lengthCheckZero
    ) {
      CommonToast({
        text: "Category can't be blank",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
  };

  const openAssociatedAccountsFound = () => {
    setRemPan(viewInternalAccountDetailData?.internal_accounts[0].pan_no);
    dispatch(beneLookUp({ pan_number: currentAccountDetails.pan }));
    dispatch(
      beneBankLookUp({
        ifsc: currentAccountDetails.ifsc_code,
        bank_account_no: currentAccountDetails.bank_acc_no,
        bank_account_holder_full_name:
          currentAccountDetails.bank_account_holder_full_name,
      }),
    );

    setOpenInternalAssociate(true);
  };

  const openTransactionHistory = () => {
    setOpenTxnHistory(true);
  };

  const handleClosePopup = () => {
    setShowDeclinePopup(false);
    if (payload?.type === "scheduleAcc") {
      setShowScheduleTxnPopup(false);
    }
    setRejectFlowType("");
    setShowLoader(false);
  };

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const capitalizeName = (str) => {
    return str
      ? str
          .split(" ")
          .map(
            (word) =>
              word.charAt(GlobalConfiguration?.lengthCheckZero).toUpperCase() +
              word.slice(GlobalConfiguration?.lengthCheckOne).toLowerCase(),
          )
          .join(" ")
      : "";
  };

  const isArchived =
    viewInternalAccountDetailData?.internal_accounts[0]?.approval_status ===
    "archived";
  const isBlocked =
    viewInternalAccountDetailData?.internal_accounts[0]?.approval_status ===
    "blocked";

  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");

  const isServiceMissing = !(hasALabel && hasRLabel);

  const handleRejectScheduleInternalTxn = async () => {
    setShowLoader(true);

    let id2 =
      !schedulesInternalTxnViewAllLoading &&
      schedulesInternalTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? schedulesInternalTxnViewAllData?.transactions.map(
            (data) => data?.txn_id,
          )
        : [];

    if (id2.length === GlobalConfiguration.lengthCheckZero) {
      setShowLoader(false);
      return;
    }

    try {
      const data2 = await dispatch(
        schedulesInternalTxnReject({
          id: id2,
          type: "scheduleInternalTxn",
          reason: declineReason,
          services,
        }),
      );

      UniversalRefreshToast("Rejecting transaction");

      if (data2?.payload?.status === false) {
        const error_msg2 =
          data2?.payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ] ||
          (Array.isArray(data2?.payload?.errors?.base) &&
          Array.isArray(
            data2?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors,
          )
            ? data2.payload.errors.base[GlobalConfiguration.lengthCheckZero]
                .errors[GlobalConfiguration.lengthCheckZero]
            : data2?.payload?.errors?.base?.[
                GlobalConfiguration.lengthCheckZero
              ]) ||
          "Unknown error occurred";

        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);

        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
        });

        const currentAccountId = deniedId || resolvedAccountId;

        await dispatch(viewInternalAccountDetail({ id: currentAccountId }));

        if (rejectFlowType === "rejectAccount") {
          await handleInternalAccountreject(currentAccountId, declineReason);
        } else if (rejectFlowType === "rejectSchedulesOnly") {
        }
      }
    } catch (error) {
      console.error("Error rejecting schedules:", error);
      CommonToast({
        text: "Something went wrong while rejecting schedules",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setShowLoader(false);
      setDeclineReason("");
      setAssociateType("");
    }
  };

  const handleInternalAccountreject = async (id, AccountIdData) => {
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (
      !beneInternalDeniedApprovalLoading ||
      beneInternalDeniedApprovalLoading === null
    ) {
      const data = await dispatch(
        beneInternalDeniedApproval({ id, AccountIdData }),
      );

      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAAccount",
          },
        });
        return;
      }

      setShowLoader(true);
      // SetCancleButtonHide(false);
      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false) {
        let error_msg = "";
        if (
          data?.payload?.errors?.internal_account?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            data?.payload?.errors?.internal_account?.[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (
          data?.payload?.errors?.bank_account_number?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          error_msg =
            data?.payload?.errors?.bank_account_number[
              GlobalConfiguration.lengthCheckZero
            ];
        } else if (data?.payload?.errors?.beneficiary_account) {
          error_msg = data?.payload?.errors?.beneficiary_account[0];
        } else {
          error_msg = "An unknown error occurred.";
        }
        setErrorStrip(error_msg);
        setShowDeclinePopup(false);
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);
        try {
          const err_msg = error_msg;
          const updatedAccounts =
            data?.payload?.internal_accounts ||
            viewInternalAccountDetailData?.internal_accounts ||
            [];
          if (updatedAccounts.length === GlobalConfiguration.lengthCheckZero) {
            setViewIntData([
              {
                ...(viewInternalAccountDetailData?.internal_accounts?.[
                  GlobalConfiguration.lengthCheckZero
                ] || {}),
                error_msg: err_msg,
              },
            ]);
          } else {
            if (!updatedAccounts[GlobalConfiguration.lengthCheckZero].error_msg)
              updatedAccounts[GlobalConfiguration.lengthCheckZero].error_msg =
                err_msg;
            setViewIntData(updatedAccounts);
          }
        } catch (e) {}
        toast.dismiss();
        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPopup(false);
        if (data?.payload?.status === true) {
          toast.dismiss();
          CommonToast({
            text: "Account rejected successfully.",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
          });
        }
        await dispatch(viewInternalAccountDetail({ id: resolvedAccountId }));
        setShowDeclinePopup(false);
        if (payload?.type === "bene_account_detail_modal") {
          await new Promise((resolve) => {
            setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
          });
          payload?.closeBeneAccountDetailModal?.();
          await payload?.onAccountUpdated?.();
        }
      }
    }
  };

  const handleClick = () => {
    if (isArchived) return;

    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  async function fetchData() {
    if (viewInternalAccountDetailLoading) setLoading(true);
    try {
      let response;
      if (payload?.type === "bene_account_detail_modal") {
        response = await dispatch(
          viewInternalAccountDetail({ id: payload?.bene_account_id }),
        );
        setLabelDetails(response?.payload?.internal_accounts[0]?.labels || []);
        setShowAdditionalRecipient(
          response?.payload?.internal_accounts?.[0]?.recipient_email || [],
        );
        setAdditionalChip(
          response?.payload?.internal_accounts?.[0]?.recipient_email || [],
        );
      } else {
        response = await dispatch(viewInternalAccountDetail({ id }));
        setLabelDetails(response?.payload?.internal_accounts[0]?.labels || []);
        setShowAdditionalRecipient(
          response?.payload?.internal_accounts?.[0]?.recipient_email || [],
        );
      }

      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    } catch (error) {
      console.error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }

  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (recipientButtonDisabled) return;
    const recipientString = [...recipients, ...additionalChip].join(",");
    let response = await dispatch(
      editInternal({ id: id, recipient_email: recipientString, navigate }),
    );
    if (response?.payload?.status) {
      setShowAdditionalSection(false);
      await fetchData();
      setRecipients([]);
    } else {
      setShowAdditionalSection(false);
    }
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, recordIdsFromPopup) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const accId = viewInternalAccountDetailData?.internal_accounts?.[0]?.id;
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(accId);
    const res = await dispatch(
      addInternalAccLabel({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addInternalAccLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
      await fetchData();
    }
    if (addInternalAccLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (addInternalAccLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (
    labelsToUnassign,
    recordIdsFromPopup,
  ) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const accId = viewInternalAccountDetailData?.internal_accounts?.[0]?.id;
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(accId);
    const res = await dispatch(
      removeInternalAccLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalAccLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
      await fetchData();
    }
    if (removeInternalAccLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (removeInternalAccLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  let approvalEntry = [
    {
      heading: "Created by",
      content: capitalizeName(
        viewInternalAccountDetailData?.internal_accounts[0]?.created_by_name,
      ),
      type: "text",
    },
    {
      heading: "Created on",
      content: viewInternalAccountDetailData?.internal_accounts[0]?.created_on
        ? formatDateViewAll(
            viewInternalAccountDetailData?.internal_accounts[0]?.created_on,
            true,
            false,
          )
        : "Not given",
      type: "text",
    },
  ];

  if (isBlocked) {
    approvalEntry.push(
      {
        heading: "Blocked by",
        content: capitalizeName(
          viewInternalAccountDetailData?.internal_accounts[0]?.blocked_by_name,
        ),
        type: "text",
      },
      {
        heading: "Blocked on",
        content: formatDateViewAll(
          viewInternalAccountDetailData?.internal_accounts[0]?.blocked_on,
        ),
        type: "text",
      },
    );
  } else if (
    viewInternalAccountDetailData?.internal_accounts[0]?.approval_status ===
    "rejected"
  ) {
    approvalEntry.push(
      {
        heading: "Rejected by",
        content: capitalizeName(
          viewInternalAccountDetailData?.internal_accounts[0]?.rejected_by_name,
        ),
        type: "text",
      },
      {
        heading: "Rejected on",
        content: formatDateViewAll(
          viewInternalAccountDetailData?.internal_accounts[0]?.rejected_on,
          true,
          false,
        ),

        type: "text",
      },
      {
        heading: "Rejected reason",
        content:
          viewInternalAccountDetailData?.internal_accounts[0]?.rejection_reason,

        type: "text",
      },
    );
  } else if (
    viewInternalAccountDetailData?.internal_accounts[0]?.approval_status ===
    "approved"
  ) {
    approvalEntry.push(
      {
        heading: "Approved by",
        content: capitalizeName(
          viewInternalAccountDetailData?.internal_accounts[0]?.approved_by_name,
        ),
        type: "text",
      },
      {
        heading: "Approved on",
        content: formatDateViewAll(
          viewInternalAccountDetailData?.internal_accounts[0]?.approved_on,
          true,
          false,
        ),

        type: "text",
      },
    );
  }

  function handleChipClick(id) {
    setSelectedChipIndex(id);
  }

  const asAcc =
    viewInternalAccountDetailData?.internal_accounts[0]?.associate_bank ===
      "Y" ||
    viewInternalAccountDetailData?.internal_accounts[0]?.associate_pan === "Y";

  const pendingTxn =
    viewInternalAccountDetailData?.internal_accounts[0]
      ?.pending_internal_transactions;

  const pendingScheduleTxn =
    viewInternalAccountDetailData?.internal_accounts[0]
      ?.pending_scheduled_internal_transactions;

  const buildAlerts = () => [
    ...(asAcc !== undefined
      ? asAcc
        ? [
            {
              isDisabled: payload.type === "bene_account_detail_modal",
              isLoading: false,
              text: "Associated accounts are found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (payload.type === "bene_account_detail_modal") {
                  actionRestricted();
                } else {
                  openAssociatedAccountsFound(
                    viewInternalAccountDetailData?.internal_accounts[0]
                      ?.ifsc_code,
                    viewInternalAccountDetailData?.internal_accounts[0]
                      ?.bank_acc_no,
                    viewInternalAccountDetailData?.internal_accounts[0]?.pan_no,
                    viewInternalAccountDetailData?.internal_accounts[0]?.id,
                  );
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: true,
            text: "Checking associated account",
          },
        ]),

    ...(pendingTxn !== undefined
      ? pendingTxn === "Y" &&
        viewInternalAccountDetailData?.internal_accounts[0]?.approval_status ===
          "pending"
        ? [
            {
              isDisabled: payload.type === "bene_account_detail_modal",

              isLoading: false,
              text: "Pending transactions found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (payload.type === "bene_account_detail_modal") {
                  actionRestricted();
                } else {
                  setdeclineType("");
                  setShowRejectPopup(true);
                  setAssociateType("InternalTxn");
                  setRejectFlowType("rejectTransactionsOnly");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: true,
            text: "Checking pending transactions",
          },
        ]),

    ...(pendingScheduleTxn !== undefined
      ? pendingScheduleTxn === "Y" &&
        viewInternalAccountDetailData?.internal_accounts[0]?.approval_status ===
          "pending"
        ? [
            {
              isDisabled: payload.type === "bene_account_detail_modal",

              isLoading: false,
              text: "Pending schedules found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (payload.type === "bene_account_detail_modal") {
                  actionRestricted();
                } else {
                  setShowScheduleTxnPopup(true);
                  setAssociateType("scheduleInternalTxn");
                  setRejectFlowType("rejectSchedulesOnly");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: true,
            text: "Checking schedule pending transactions",
          },
        ]),
  ];

  const chipsArray = [
    {
      text: "IFSC code",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckZero,
      disabled: true,
    },
    {
      text: "Name, Contact number, Email ID",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckOne,
      disabled: false,
      bulletPoint: ["Require approval."],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckOne),
    },
    {
      text: "Categories",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckTwo,
      disabled: true,
    },
    {
      text: "PAN number, GST number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckThree,
      disabled: true,
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      disabled: true,
    },
  ];

  const handleApply = () => {
    if (selectedChipIndex === GlobalConfiguration?.lengthCheckOne) {
      navigate(
        `/internal_account_dashboard/view_details/contact_details/${id}`,
      );
    }
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);

    const accountInfo = await dispatch(
      viewInternalAccountDetail({ id: id || deniedId || resolvedAccountId }),
    );
    if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "Y" &&
      (accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y" ||
        accountInfo?.payload?.internal_accounts?.[0]
          ?.pending_scheduled_internal_transactions === "N")
    ) {
      setShowDeclinePopup(false);
      setAssociateType("InternalTxn");
      setShowRejectPopup(true);
    } else if (
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_internal_transactions === "N" &&
      accountInfo?.payload?.internal_accounts?.[0]
        ?.pending_scheduled_internal_transactions === "Y"
    ) {
      setShowDeclinePopup(false);
      setDeclineReason("");
      setShowScheduleTxnPopup(true);
    } else {
      handleInternalAccountreject(id, AccountIdData);
    }
  };

  const handleConfirmAlert = async () => {
    let openedSchedules = false;
    setShowLoader(true);

    try {
      const AccountIdData = declineReason;
      let all_txn_id = [];

      all_txn_id =
        !internalTxnViewAllAccLoading &&
        internalTxnViewAllAccData?.transactions?.length >
          GlobalConfiguration.lengthCheckZero
          ? internalTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
          : [];

      UniversalRefreshToast("Rejecting transaction");

      let data = null;

      if (all_txn_id.length > GlobalConfiguration.lengthCheckZero) {
        data = await dispatch(
          internalTxnMultiRejectApproval({ id: all_txn_id, AccountIdData }),
        );
      }

      if (data?.payload?.status === false) {
        setShowRejectPopup(false);
        const error_msg = data?.payload?.errors?.user_unauthorized
          ? data?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data?.payload?.errors?.base) &&
              Array.isArray(data?.payload?.errors?.base[0]?.errors)
            ? data.payload.errors.base[0].errors[0]
            : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        return;
      }

      if (
        data?.payload?.status === true ||
        all_txn_id.length === GlobalConfiguration.lengthCheckZero
      ) {
        setShowRejectPopup(false);
        setShowDeclinePopup(false);

        toast.dismiss();
        CommonToast({
          text: "Transactions rejected successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
        });

        const currentAccountId = deniedId || resolvedAccountId;

        const refreshed = await dispatch(
          viewInternalAccountDetail({ id: currentAccountId }),
        );

        const pendingScheduleFlag =
          refreshed?.payload?.internal_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ]?.pending_scheduled_internal_transactions;

        if (rejectFlowType === "rejectAccount") {
          if (pendingScheduleFlag === "Y") {
            openedSchedules = true;
            setAssociateType("rejectAccount");
            setShowScheduleTxnPopup(true);
          } else {
            await handleInternalAccountreject(
              refreshed?.payload?.internal_accounts?.[
                GlobalConfiguration.lengthCheckZero
              ]?.id || currentAccountId,
              declineReason,
            );
          }
        } else if (rejectFlowType === "rejectTransactionsOnly") {
          await dispatch(viewInternalAccountDetail({ id: currentAccountId }));
        }
      } else if (data?.payload === undefined) {
        setShowRejectPopup(false);
        CommonToast({
          text: "An error occurred while taking action on this account",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      console.error(error);
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    } finally {
      setShowLoader(false);
      if (associateType === "InternalTxn" && !openedSchedules) {
        setDeclineReason("");
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        let response;
        if (payload?.type === "bene_account_detail_modal") {
          response = await dispatch(
            viewInternalAccountDetail({ id: payload?.bene_account_id }),
          );
        } else {
          response = await dispatch(viewInternalAccountDetail({ id }));
        }

        if (
          !response?.payload ||
          response?.error?.status === errorcode.errorNotFound ||
          response?.error?.status === errorcode.errorUnAuthorized
        ) {
          navigate("/*");
          return;
        }
        setViewIntData(response?.payload?.internal_accounts);
        const account =
          response?.payload?.internal_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ] || {};

        setLabelDetails(account?.labels || []);
        setShowAdditionalRecipient(account?.recipient_email || []);
      } catch (error) {
        console.error("Failed to load the account details", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [payload?.bene_account_id, id, dispatch]);

  useEffect(() => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      return;
    }

    const bankAccNo =
      viewInternalAccountDetailData?.internal_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.bank_acc_no;
    const panNo =
      viewInternalAccountDetailData?.internal_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.pan_no;
    const ifscCode =
      viewInternalAccountDetailData?.internal_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ]?.ifsc_code;

    if (!bankAccNo || !panNo || !ifscCode) return;

    const fetchOwnerID = async () => {
      if (ensureAll(["VAccount"]).status) {
        hasFetchedOwner.current = true;
        const data = await dispatch(
          ownerListViewAllAcc({
            bank_account_no: bankAccNo,
            pan: panNo,
            ifsc: ifscCode,
          }),
        );
        setOwnerAccountId(
          data?.payload?.owner_accounts?.[GlobalConfiguration.lengthCheckZero]
            ?.id,
        );
      }
    };

    if (!hasFetchedOwner.current) {
      fetchOwnerID();
    }
    setViewIntData(viewInternalAccountDetailData?.internal_accounts);
  }, [
    viewInternalAccountDetailData,
    viewInternalAccountDetailData?.internal_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ]?.bank_acc_no,
    viewInternalAccountDetailData?.internal_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ]?.pan_no,
    viewInternalAccountDetailData?.internal_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ]?.ifsc_code,
    services,
  ]);
  useEffect(() => {
    if (
      viewInternalAccountDetailData &&
      viewInternalAccountDetailData.internal_accounts &&
      viewInternalAccountDetailData.internal_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const { bank_name, bank_acc_no, category, ifsc_code, id, pan_no, name } =
        viewInternalAccountDetailData.internal_accounts[
          GlobalConfiguration.lengthCheckZero
        ];
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [viewInternalAccountDetailData]);

  useEffect(() => {
    let availableLabels = sessionStorage?.getItem("AvailableLabelsInternal");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    viewInternalAccountDetailData?.internal_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ]?.labels,
  ]);

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  const hasAccess =
    services?.includes("AInternalTxn") || services?.includes("Admin");

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {editPopUp && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            isalert={true}
            alertImage={ICONS?.ERROR_WHITE_CIRCLE}
            btnOneHandleFunction={() => {
              setEditPopUp(false);
              setSelectedChipIndex(null);
            }}
            headerTitle="Select the option you would like to edit:"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            alertText="Since this is an internal account other features have been disabled"
            alertTextFont={"text-primary"}
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoInActiveVariantNeeded
            btnTwoHandleFunction={handleApply}
            btnTwoIsDisabled={selectedChipIndex === null}
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {showDeclinePopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            inputPlaceholder="Reason (10-150 char)"
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (showLoader) return;
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                setDeclineReason("");
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "scheduleInternalTxn") {
                handleRejectScheduleInternalTxn();
              } else if (associateType === "InternalTxn") {
                handleConfirmAlert();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoInActiveVariantNeeded
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {openInternalAssociate && (
        <LargePopupRedirect
          headerTitle="Associated accounts"
          headersubtext="The accounts listed below are linked to the selected internal account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setOpenInternalAssociate(false);
            setRemPan("");
            setRemAccount("");
            setRemIFSC("");
            setActiveType("pan");
            setRejectFlowType("");
          }}
          closeicon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          confirmbtnrequired={true}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
          ispanbankRequired={true}
          togglepan={() => {
            setActiveType("pan");
            setRemPan(
              viewInternalAccountDetailData?.internal_accounts[0].pan_no,
            );
            setRemAccount("");
            setRemIFSC("");
            // setSearchPanText(
            //   viewInternalAccountDetailData?.internal_accounts[0].pan_no,
            // );
          }}
          toggleBank={() => {
            setActiveType("bank");
            setRemPan("");
            setRemAccount(
              viewInternalAccountDetailData?.internal_accounts[0].bank_acc_no,
            );
            setRemIFSC(
              viewInternalAccountDetailData?.internal_accounts[0].ifsc_code,
            );

            // setSearchPanText(
            //   viewInternalAccountDetailData?.internal_accounts[0].pan_no,
            // );
          }}
        >
          <InternalAccountViewAll
            id={viewInternalAccountDetailData?.internal_accounts[0].id}
            typePanBank={"BeneAccPanBankSwitch"}
            typepop={"popup"}
            flow={"detailPage"}
            remPan={remPan}
            remAccount={remAccount}
            remIFSC={remIFSC}
            activeType={activeType}
            associateAccount={true}
            // searchPanText={searchPanText}
            currentAccountDetails={
              viewInternalAccountDetailData?.internal_accounts
            }
            setOpenBeneAssociate={(e) => {}}
            onCardNavigate={(redirectUrl) => {
              setLoading(true);
              setOpenInternalAssociate(false);
              navigate(redirectUrl);
              setRemPan("");
              setRemAccount("");
              setRemIFSC("");
            }}
            handleButtonClick={(account) => {
              setLoading(true);
              setOpenInternalAssociate(false);
              navigate(
                `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${account.id}`,
              );
              setRemPan("");
              setRemAccount("");
              setRemIFSC("");
            }}
          />
        </LargePopupRedirect>
      )}

      {showRejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-max bg-custom-backdrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Associated transactions found"
            headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setShowRejectPopup(false);
              setRejectFlowType("");
            }}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              hasAccess
                ? "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
                : "To reject the transactions, please contact the authorised person who has the feature to reject the transactions."
            }
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              const servicesReq = ["AInternalTxn"];

              if (servicesReq.some((service) => services.includes(service))) {
                if (associateType === "InternalTxn") {
                  if (
                    declineReason &&
                    declineReason.length >= GlobalConfiguration.panLength
                  ) {
                    handleConfirmAlert();
                  } else {
                    setShowDeclinePopup(true);
                  }
                } else {
                  handleConfirmAlert();
                }
              }

              if (!hasAccess) {
                navigate("/feature_not_assigned", {
                  state: { unavailableService: "AInternalTxn" },
                });
                return;
              }
            }}
            enabledBgColor={
              hasAccess ? "var(--negative-act)" : "var(--text-disabled)"
            }
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={!hasAccess}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            {viewInternalAccountDetailData?.internal_accounts?.[
              GlobalConfiguration.lengthCheckZero
            ]?.id && (
              <InternalTransactionViewAll
                typepop={"RejectInternalAcc"}
                type={
                  declineType === "rejectedAccount"
                    ? "Internal_AccountApproval"
                    : "RejectInternalTxn"
                }
                internal_acc_id={
                  viewInternalAccountDetailData?.internal_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ]?.id
                }
                internal_acc_name={
                  viewInternalAccountDetailData?.internal_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ]?.name
                }
                bank_acc_no={
                  viewInternalAccountDetailData?.internal_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ]?.bank_acc_no
                }
                OwnerDetail={true}
                balanceType={"credit"}
                BeneAccId={
                  viewInternalAccountDetailData?.internal_accounts[
                    GlobalConfiguration.lengthCheckZero
                  ]?.id
                }
                closeRejectAllTxn={() => setShowRejectPopup(false)}
                setShowLoader={setShowLoader}
                setSidebarState={(e) => {}}
                setFocus={(e) => {}}
              />
            )}
          </LargePopupRedirect>
        </div>
      )}

      {showScheduleTxnPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center  z-z-index-max bg-custom-backdrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Associated schedules found"
            headersubtext="The following schedules are linked and need to be rejected before rejecting this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => {
              setShowScheduleTxnPopup(false);
              setRejectFlowType("");
            }}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText={
              "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
            }
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              if (associateType === "scheduleInternalTxn") {
                if (
                  declineReason &&
                  declineReason.length >= GlobalConfiguration.panLength
                ) {
                  handleRejectScheduleInternalTxn();
                } else {
                  setShowDeclinePopup(true);
                }
              } else {
                handleRejectScheduleInternalTxn();
              }
            }}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <ScheduleInternalTransactionViewSchedule
              type={"scheduleInternalAcc"}
              txnHistorytype={"scheduleInternalAccApproval"}
              internal_account_id={
                viewInternalAccountDetailData?.internal_accounts[0]?.id
              }
              internal_account_name={
                viewInternalAccountDetailData?.internal_accounts[0]?.name
              }
              closeCallback={handleClosePopup}
            />
          </LargePopupRedirect>
        </div>
      )}

      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}
      {isEditModalOpen && (
        <EditCommonPopup
          btnOneHandleFunction={handleModalClose}
          headerTitle="Select the option you would like to edit:"
          alertBackground="emphasis"
          chipsArray={chipsArray}
          btnOneText="Cancel"
          btnOneEnabledBgColor="var(--primary-bg)"
          btnOneEnabledTextColor="var(--text-primary)"
          btnOneHoverOption="white"
          btnOneOutLineColor="var(--text-primary)"
          btnTwoText="Edit"
          btnTwoHandleFunction={handleApply}
          btnTwoIsDisabled={
            selectedChipIndex === null ||
            selectedChipIndex === GlobalConfiguration.lengthCheckZero
          }
          btnTwoDisabledTextColor="var(--text-primary)"
          btnTwoEnabledBgColor="var(--text-primary)"
          btnTwoEnabledTextColor="var(--primary-bg)"
          // btnTwoIsLoaderNeeded={handleLoading}
          btnTwoDisabledBgColor="var(--text-disabled)"
          btnTwoHoverOption="black"
        />
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state:
                viewInternalAccountDetailData?.internal_accounts[0]
                  ?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={
              viewInternalAccountDetailData?.internal_accounts[0]?.gstin_detail
            }
            popup={true}
          />
        </LargePopupRedirect>
      )}
      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${viewInternalAccountDetailData?.internal_accounts[0]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <OwnerAccountIFSC
              ifsc_code={
                viewInternalAccountDetailData?.internal_accounts[0]?.ifsc_code
              }
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state:
                  viewInternalAccountDetailData?.internal_accounts[0]?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={
                viewInternalAccountDetailData?.internal_accounts[0]?.pan_no
              }
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={[
              viewInternalAccountDetailData?.internal_accounts?.[0]?.id,
            ].filter(Boolean)}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={[
              viewInternalAccountDetailData?.internal_accounts?.[0],
            ].filter(Boolean)}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-full h-full flex items-center bg-Primary-black justify-center z-z-index-modal bg-opacity-dark-opacity">
          <FullScreen
            type={"internalAcc"}
            id={payload?.bene_account_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      <div
        className={`mob-nav-bar ${payload?.type === "bene_account_detail_modal" ? "hidden" : "block"} z-z-index-overlay fixed w-full Qsmd:hidden flex items-start bg-primary-nav`}
      >
        <TopNavComponent
          isFormattingNotRequired={true}
          topNavHeader={"Internal"}
          topNavSubText="Internal details"
        />
      </div>
      <div
        className={`${
          payload?.type === "bene_account_detail_modal"
            ? "main-div overflow-hidden overflow-y-scroll bg-primary-bg h-full"
            : editPopUp ||
                showGstPopup ||
                alertPopUp ||
                showPanPopup ||
                showGstPopup ||
                showIfscPopup ||
                showLabelsPopup ||
                showScheduleTxnPopup ||
                showDeclinePopup ||
                openTxnHistory ||
                openInternalAssociate ||
                showRejectPopup
              ? "main-div flex flex-col h-screen overflow-y-hidden overflow-x-hidden"
              : "main-div flex flex-col  overflow-x-hidden "
        }`}
      >
        {openTxnHistory && (
          <LargePopupRedirect
            headerTitle={"Transaction history"}
            headersubtext={
              "All transactions related to the internal are listed below."
            }
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => setOpenTxnHistory(false)}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <InternalTransactionViewAll
              Owner_account_number={
                viewInternalAccountDetailData?.internal_accounts[0]?.bank_acc_no
              }
              txnHistorytype={"internalTxnHistory"}
              BeneAccId={id}
            />
          </LargePopupRedirect>
        )}

        {loading ? (
          <>
            <div className="bene-detail-loader-box m-auto justify-center items-center flex !h-full-height">
              <Loader />
            </div>
          </>
        ) : (
          <>
            <div
              className={`${
                payload?.type === "bene_account_detail_modal"
                  ? "h-auto bg-primary-nav hidden Qlg:block "
                  : "h-auto bg-primary-nav hidden Qlg:block"
              }`}
            >
              <div
                className={`w-full max-w-tab-width-normal m-auto bg-primary-nav ${payload?.type !== "bene_account_detail_modal" ? "primaryDetailsandFunctionblock" : ""}`}
              >
                <div className=" flex flex-row border-b border-solid border-primary-bg justify-center mt-margin-xs">
                  <div className="w-width-full flex flex-row py-padding-md">
                    <div className="accountName Qmd:pl-padding-sm flex flex-col w-width-md gap-y-gap-xs whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        subtitle="Account name"
                        title={accountNameStandardised(
                          viewInternalAccountDetailData?.internal_accounts[0]?.name?.trim(),
                        )}
                        titleColor="text-primary"
                        variant="md"
                      />
                    </div>
                    <div className="border-r border-solid border-primary-bg"></div>
                    {viewIntData?.map((account) => (
                      <div className="accountStatus flex flex-col w-width-md gap-y-gap-xs pl-padding-md justify-center">
                        <TitleSubtitlePair
                          subtitle="Account status"
                          titleColor={
                            account.approval_status === "pending" ||
                            account.approval_status === "error"
                              ? "pending"
                              : account.approval_status === "approved"
                                ? "awaiting"
                                : account.approval_status === "rejected"
                                  ? "failed"
                                  : account.approval_status === "blocked"
                                    ? "failed"
                                    : "abandoned"
                          }
                          variant="md"
                          title={
                            account.approval_status === "pending" ||
                            account.approval_status === "error"
                              ? "Pending"
                              : account.approval_status === "approved"
                                ? "Approved"
                                : account.approval_status === "rejected"
                                  ? "Rejected"
                                  : account.approval_status === "blocked"
                                    ? "Blocked"
                                    : "Abandoned"
                          }
                          isBold={true}
                        />
                      </div>
                    ))}
                  </div>
                  <div
                    className={`${
                      payload.type === "bene_account_detail_modal"
                        ? "flex flex-row bg-primary-nav-act opacity-light-opacity cursor-default"
                        : "flex flex-row bg-primary-nav-act "
                    }`}
                  >
                    <TopNavSmallButton
                      btnText={
                        <>
                          Linked owner <br /> account
                        </>
                      }
                      icon={
                        "https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                      }
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (payload.type === "bene_account_detail_modal") {
                          actionRestricted();
                          return;
                        }
                        if (owneraccountId) {
                          navigate(
                            `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${owneraccountId}`,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VAccount",
                            },
                          });
                        }
                      }}
                      isDisabled={payload.type === "bene_account_detail_modal"}
                    />

                    <div className="border-r border-solid border-primary-bg my-margin-sm"></div>

                    <TopNavSmallButton
                      btnText={
                        <>
                          Associated <br /> accounts
                        </>
                      }
                      icon={
                        "https://q2pay.in/new_assets/common/detail_page/associated_accounts_found.svg"
                      }
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (payload.type === "bene_account_detail_modal") {
                          actionRestricted();
                        } else {
                          openAssociatedAccountsFound();
                        }
                      }}
                      isDisabled={payload.type === "bene_account_detail_modal"}
                    />
                  </div>
                </div>
                <div className="primaryDetailsBlock2 flex flex-row border-b border-solid border-primary-bg justify-center">
                  <div className="flex flex-row py-padding-md w-full">
                    <div className="w-width-md Qmd:pl-padding-sm flex flex-col gap-y-gap-xs justify-center">
                      <TitleSubtitlePair
                        subtitle="Account number"
                        title={formatAccountNumber(
                          viewInternalAccountDetailData?.internal_accounts[0]
                            ?.bank_acc_no,
                        )}
                        titleColor="text-primary"
                        variant="md"
                      />
                    </div>
                    <div className="border-r border-solid border-primary-bg"></div>
                    <div className="accountHolderName flex flex-col w-width-md gap-y-gap-xs px-padding-md whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        subtitle="Bank account holder name"
                        title={capitalizeName(
                          viewInternalAccountDetailData?.internal_accounts[0]
                            ?.bank_account_holder_full_name,
                        )}
                        titleColor="text-primary"
                        variant="md"
                      />
                    </div>
                  </div>
                  <div
                    className={`flex flex-row ${
                      payload.type === "bene_account_detail_modal"
                        ? " bg-primary-nav-act opacity-light-opacity cursor-default"
                        : "bg-primary-nav-act"
                    }`}
                  >
                    <TopNavSmallButton
                      btnText={
                        <>
                          Edit
                          <br /> account
                        </>
                      }
                      icon={
                        "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                      }
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (
                          viewInternalAccountDetailData?.internal_accounts[0]
                            ?.approval_status === "archived" ||
                          viewInternalAccountDetailData?.internal_accounts[0]
                            ?.approval_status === "blocked"
                        )
                          return;
                        if (payload.type === "bene_account_detail_modal") {
                          actionRestricted();
                        } else {
                          setEditPopUp(true);
                        }
                      }}
                      isDisabled={
                        payload.type === "bene_account_detail_modal" ||
                        viewInternalAccountDetailData?.internal_accounts[0]
                          ?.approval_status === "archived" ||
                        viewInternalAccountDetailData?.internal_accounts[0]
                          ?.approval_status === "blocked"
                      }
                    />
                    <div className="border-r border-solid border-primary-bg my-margin-sm"></div>

                    <TopNavSmallButton
                      btnText={
                        <>
                          Transaction <br /> history
                        </>
                      }
                      icon={
                        "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                      }
                      hoverOption={"white"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary)"}
                      disabledBgColor={"var(--primary-nav-act)"}
                      disabledTextColor={"var(--text-primary)"}
                      handleFunction={() => {
                        if (payload.type === "bene_account_detail_modal") {
                          actionRestricted();
                        } else {
                          openTransactionHistory();
                        }
                      }}
                      isDisabled={payload.type === "bene_account_detail_modal"}
                    />
                  </div>
                </div>
                <div className="primaryDetailsBlock3 flex flex-row justify-between">
                  {viewIntData.map((account) => (
                    <>
                      <div
                        className={`flex ${
                          account?.error_msg
                            ? "ifscCodeBlock_Error"
                            : "w-width-lg"
                        }`}
                      >
                        <div className="w-width-md flex justify-between items-center">
                          <div
                            className={`bankIfscCode flex ${account.approval_status === "pending" || account.approval_status === "approved" ? "" : "py-padding-sm"}`}
                          >
                            {/* <div className=` ${}`></div> */}
                            <div
                              className={`flex flex-col gap-y-gap-xs p-padding-sm ${
                                payload?.type === "bene_account_detail_modal"
                                  ? "cursor-not-allowed opacity-light-opacity"
                                  : "rounded-lg cursor-pointer global-hover-white relative z-z-index-base"
                              }`}
                              onClick={() => {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "VIFSC" ||
                                      service === "Admin",
                                  ) !== undefined &&
                                  viewInternalAccountDetailData
                                    ?.internal_accounts[0]?.ifsc_code
                                ) {
                                  if (
                                    payload.type === "bene_account_detail_modal"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    setIfscShowPopup(true);
                                    // navigate(
                                    //   `/settings/IFSC_verification/IFSC_Details/${viewInternalAccountDetailData?.internal_accounts[0]?.ifsc_code}`,
                                    // );
                                  }
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VIFSC",
                                    },
                                  });
                                }
                              }}
                            >
                              <div className="flex flex-row justify-between gap-x-gap-sm">
                                <span className="text-font-md text-text-primary font-normal font-sans ">
                                  {
                                    viewInternalAccountDetailData
                                      ?.internal_accounts[0]?.ifsc_code
                                  }
                                </span>
                                <div className="flex justify-center items-center">
                                  <SVGComponent
                                    color="var(--text-primary)"
                                    url="https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                                    width="var(--icon-sm)"
                                    height="var(--icon-sm)"
                                  />
                                </div>
                              </div>
                              <span className="text-font-xs text-text-secondary font-normal font-sans ">
                                IFSC code
                              </span>
                            </div>
                          </div>
                          <div className="h-[max-content]">
                            <CommonBankLogo
                              ifsc={
                                viewInternalAccountDetailData
                                  ?.internal_accounts[0]?.ifsc_code
                              }
                              variant="big"
                              type="pill"
                            />
                          </div>
                        </div>
                        <div className="w-width-md"></div>
                      </div>
                      <div
                        className={`flex ${
                          account?.error_msg
                            ? "functionBlock_Error"
                            : "w-width-sm  justify-end"
                        }`}
                      >
                        {viewIntData.map((account) => (
                          <div key={account.id}>
                            {showLoader || showDeclinePopup ? (
                              <div className="w-max-button-width-for-approval-animation flex">
                                <div
                                  className={`w-width-full flex justify-center items-center ${
                                    clickedBtn === "reject"
                                      ? "bg-negative-act"
                                      : "bg-positive-act"
                                  } py-padding-lg`}
                                >
                                  <Loader
                                    height="var(--icon-lg)"
                                    width="var(--icon-lg)"
                                  />
                                </div>
                              </div>
                            ) : account?.approval_status === "approved" ? (
                              <TopNavLargeButton
                                enabledBgColor={"var(--positive-act)"}
                                isDisabled={
                                  !services?.some(
                                    (service) =>
                                      service === "CInternalTxn" ||
                                      service === "Admin",
                                  ) || payload?.internalAccDetailOpen
                                }
                                btnText={"Initiate internal transaction"}
                                icon="https://q2pay.in/new_assets/common/detail_page/initiate_internal_transaction.svg"
                                hoverOption={"black"}
                                enabledTextColor={"var(--text-primary)"}
                                handleFunction={() => {
                                  if (
                                    payload.type === "bene_account_detail_modal"
                                  ) {
                                    actionRestricted();
                                    return;
                                  } else if (
                                    services?.some(
                                      (service) =>
                                        service === "CInternalTxn" ||
                                        service === "Admin",
                                    ) ||
                                    payload.openTransHistory
                                  ) {
                                    createIntTransaction();
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "CInternalTxn",
                                      },
                                    });
                                  }
                                }}
                              />
                            ) : account?.approval_status === "rejected" &&
                              errorStrip.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div
                                key={account.id}
                                className={`pay-bene-box2 flex justify-end w-[var(--category-popup-height)]`}
                              >
                                <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm py-padding-button-l">
                                  <div className="flex place-items-center">
                                    <div className="flex place-items-center">
                                      <img
                                        src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                                        className="functionBlockImg"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                    <span className="font-semibold font-sans text-font-sm text-text-primary">
                                      Failed to take action
                                    </span>
                                    <span className="text-font-xs text-text-primary errorMsg break-words">
                                      {errorStrip ||
                                        "An error occurred while taking action on this account"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account.approval_status === "pending" &&
                              errorStrip.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div
                                key={account.id}
                                className={`pay-bene-box2 flex justify-end w-[var(--category-popup-height)]`}
                              >
                                <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm py-padding-button-l">
                                  <div className="flex place-items-center">
                                    <div className="flex place-items-center">
                                      <img
                                        src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                                        className="functionBlockImg"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                    <span className="font-semibold font-sans text-font-sm text-text-primary">
                                      Failed to take action
                                    </span>

                                    <span className="text-font-xs text-text-primary errorMsg break-words">
                                      {errorStrip ||
                                        "An error occurred while taking action on this account"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account.approval_status === "error" ||
                              errorStrip.length >
                                GlobalConfiguration?.lengthCheckZero ? (
                              <div
                                key={account.id}
                                className={`pay-bene-box2 flex justify-end w-[var(--category-popup-height)]`}
                              >
                                <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm py-padding-button-l">
                                  <div className="flex place-items-center">
                                    <div className="flex place-items-center">
                                      <img
                                        src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                                        className="functionBlockImg"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                    <span className="font-semibold font-sans text-font-sm text-text-primary">
                                      Failed to take action
                                    </span>

                                    <span className="text-font-xs text-text-primary errorMsg break-words">
                                      {errorStrip ||
                                        "An error occurred while taking action on this account"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ) : account.approval_status === "pending" ? (
                              <div className="w-full flex flex-row justify-end">
                                <TopNavSmallButton
                                  enabledBgColor={"var(--negative-act)"}
                                  btnText={
                                    <>
                                      Reject <br /> account
                                    </>
                                  }
                                  icon="https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg"
                                  hoverOption={"black"}
                                  enabledTextColor={"var(--text-primary)"}
                                  isDisabled={
                                    !services?.some(
                                      (service) =>
                                        service === "IAAccount" ||
                                        service === "Admin",
                                    )
                                  }
                                  handleFunction={() => {
                                    if (
                                      services?.some(
                                        (service) =>
                                          service === "IAAccount" ||
                                          service === "Admin",
                                      )
                                    ) {
                                      handleDeclinedDetials(
                                        viewInternalAccountDetailData
                                          ?.internal_accounts[
                                          GlobalConfiguration.lengthCheckZero
                                        ]?.id,
                                      );
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "IAAccount",
                                        },
                                      });
                                    }
                                  }}
                                />

                                <TopNavSmallButton
                                  enabledBgColor={"var(--positive-act)"}
                                  btnText={
                                    <>
                                      Approve <br /> account
                                    </>
                                  }
                                  icon="https://q2pay.in/new_assets/common/approval/approve_circle_green_checkmark.svg"
                                  hoverOption={"black"}
                                  enabledTextColor={"var(--text-primary)"}
                                  isDisabled={
                                    !services?.some(
                                      (service) =>
                                        service === "IAAccount" ||
                                        service === "Admin",
                                    )
                                  }
                                  handleFunction={() => {
                                    if (
                                      services?.some(
                                        (service) =>
                                          service === "IAAccount" ||
                                          service === "Admin",
                                      )
                                    ) {
                                      setClickedBtn("approve");
                                      handleApprovalDetails(
                                        viewInternalAccountDetailData
                                          ?.internal_accounts[
                                          GlobalConfiguration.lengthCheckZero
                                        ]?.id,
                                      );
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "IAAccount",
                                        },
                                      });
                                    }
                                  }}
                                />
                              </div>
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`flex flex-col  bg-primary-card  Qlg:hidden  ${
                payload?.type === "bene_account_detail_modal"
                  ? ""
                  : "pt-padding-multi-cards Qsmd:pt-medium-screen-top-padding"
              }`}
            >
              <div className="flex flex-col border-b border-solid border-primary-bg p-padding-button-l Qsmd:pt-padding-base gap-y-gap-xs mx-margin-md Qlg:mx-margin-base px-padding-base">
                <p className="text-font-sm text-text-primary font-normal font-sans">
                  {accountNameStandardised(
                    viewInternalAccountDetailData?.internal_accounts[0]?.name?.trim(),
                  )}
                </p>
                <p className="text-font-xs text-text-secondary font-normal font-sans">
                  Account name
                </p>
              </div>
              {viewIntData?.map((account) => (
                <div className="flex flex-col border-b border-solid border-primary-bg p-padding-button-l gap-y-gap-xs mx-margin-md Qlg:mx-margin-base px-padding-base">
                  <p
                    className={`text-font-sm font-semibold font-sans capitalize ${
                      account.approval_status === "pending" ||
                      account.approval_status === "error"
                        ? "text-pending"
                        : account.approval_status === "approved"
                          ? "text-awaiting"
                          : account.approval_status === "rejected" ||
                              account.approval_status === "blocked"
                            ? "text-failed"
                            : "text-abandoned"
                    }`}
                  >
                    {account?.approval_status === "error"
                      ? "Pending"
                      : account?.approval_status}
                  </p>
                  <p className="text-font-xs text-text-secondary font-normal font-sans">
                    Account status
                  </p>
                </div>
              ))}
              <div className="flex flex-col border-b border-solid border-primary-bg p-padding-button-l gap-y-gap-xs mx-margin-md Qlg:mx-margin-base px-padding-base">
                <p className="text-font-sm text-text-primary font-normal font-sans">
                  {formatAccountNumber(
                    viewInternalAccountDetailData?.internal_accounts[0]
                      ?.bank_acc_no,
                  )}
                </p>
                <p className="text-font-xs text-text-secondary font-normal font-sans">
                  Account number
                </p>
              </div>
              <div className="flex border-b border-solid border-primary-bg p-padding-button-l gap-x-gap-xs justify-between items-center mx-margin-md Qlg:mx-margin-base px-padding-base">
                <div className="">
                  <p className="text-font-sm text-text-primary font-normal font-sans capitalize">
                    {capitalizeName(
                      viewInternalAccountDetailData?.internal_accounts[0]
                        ?.bank_account_holder_full_name,
                    )}
                  </p>
                  <p className="text-font-xs text-text-secondary font-normal font-sans">
                    Bank account holder name
                  </p>
                </div>
              </div>
              <div className="flex justify-between items-center Qlg:border-b border-solid  border-primary-bg Qlg:pl-padding-sm py-padding-sm mx-margin-sm  Qlg:mx-margin-base px-padding-base">
                <div
                  className={`flex items-center w-width-full justify-between gap-y-gap-xs px-padding-xs ${
                    payload?.type === "bene_account_detail_modal"
                      ? "cursor-not-allowed opacity-light-opacity"
                      : "rounded-lg cursor-pointer"
                  }`}
                  onClick={() => {
                    if (
                      services?.find(
                        (service) => service === "VIFSC" || service === "Admin",
                      ) !== undefined &&
                      viewInternalAccountDetailData?.internal_accounts[0]
                        ?.ifsc_code
                    ) {
                      if (payload.type === "bene_account_detail_modal") {
                        actionRestricted();
                      } else {
                        setIfscShowPopup(true);
                      }
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "VIFSC",
                        },
                      });
                    }
                  }}
                >
                  <TitleSubtitlePair
                    title={
                      viewInternalAccountDetailData?.internal_accounts[0]
                        ?.ifsc_code
                    }
                    subtitle="IFSC code"
                    titleColor="text-primary"
                    variant="md"
                    showArrow
                    hoverOption="white"
                  />
                  <div className="h-[max-content]">
                    <CommonBankLogo
                      ifsc={
                        viewInternalAccountDetailData?.internal_accounts[0]
                          ?.ifsc_code
                      }
                      variant="big"
                      type="pill"
                    />
                  </div>
                </div>
              </div>

              {viewIntData.map((account) => (
                <div
                  className="view in data"
                  key={account.id}
                >
                  {showLoader || showDeclinePopup ? (
                    <>
                      <div className="flex ">
                        <div className="w-max-button-width-for-approval-animation flex flex-grow">
                          <div
                            className={`w-width-full flex justify-center items-center ${
                              clickedBtn === "reject"
                                ? "bg-negative-act"
                                : "bg-positive-act"
                            } py-padding-lg`}
                          >
                            <Loader
                              height="var(--icon-lg)"
                              width="var(--icon-lg)"
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : account?.approval_status === "approved" ? (
                    <>
                      <div className="flex ">
                        <TopNavLargeButton
                          enabledBgColor={"var(--positive-act)"}
                          isDisabled={
                            !services?.find(
                              (service) =>
                                service === "CInternalTxn" ||
                                service === "Admin",
                            ) || payload?.internalAccDetailOpen
                          }
                          btnText={"Initiate internal transaction"}
                          icon="https://q2pay.in/new_assets/common/detail_page/initiate_internal_transaction.svg"
                          hoverOption={"black"}
                          fullWidthRequired={true}
                          enabledTextColor={"var(--text-primary)"}
                          handleFunction={() => {
                            if (payload.type === "bene_account_detail_modal") {
                              actionRestricted();
                              return;
                            } else if (
                              services?.find(
                                (service) =>
                                  service === "CInternalTxn" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              createIntTransaction();
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "CInternalTxn",
                                },
                              });
                            }
                          }}
                        />
                      </div>
                    </>
                  ) : account?.approval_status === "rejected" &&
                    errorStrip.length > GlobalConfiguration?.lengthCheckZero ? (
                    <div className="flex bg-negative-card">
                      <div className="flex flex-row h-full w-full bg-failed-to-take-action py-padding-md px-padding-lg">
                        <div className="flex place-items-center">
                          <img
                            src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                            className="functionBlockImg flex-shrink-0"
                            alt=""
                          />
                        </div>
                        <div className="flex flex-col gap-y-gap-xs ml-margin-sm">
                          <span className="text-font-sm text-text-primary font-sans font-semibold">
                            Failed to take action
                          </span>
                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                  [`& .${tooltipClasses.arrow}`]: {
                                    color: (theme) =>
                                      theme.palette.common.black,
                                  },
                                },
                              },
                            }}
                            title={account?.error_msg}
                            arrow
                            placement="bottom"
                            PopperProps={{ style: { maxWidth: "none" } }}
                          >
                            <span className="text-font-xxs text-text-primary font-normal font-sans text-wrap">
                              {errorStrip ||
                                "An error occurred while taking action on this account."}
                            </span>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ) : account.approval_status === "pending" &&
                    errorStrip.length > GlobalConfiguration?.lengthCheckZero ? (
                    <div className="flex bg-negative-card">
                      <div className="flex flex-row h-full w-full bg-failed-to-take-action py-padding-md px-padding-lg">
                        <div className="flex place-items-center">
                          <img
                            src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                            className="functionBlockImg flex-shrink-0"
                            alt=""
                          />
                        </div>
                        <div className="flex flex-col gap-y-gap-xs  ml-margin-sm">
                          <span className="text-font-sm text-text-primary font-sans font-semibold">
                            Failed to take action
                          </span>
                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                  [`& .${tooltipClasses.arrow}`]: {
                                    color: (theme) =>
                                      theme.palette.common.black,
                                  },
                                },
                              },
                            }}
                            title={account?.error_msg}
                            arrow
                            placement="bottom"
                            PopperProps={{ style: { maxWidth: "none" } }}
                          >
                            <span className="text-font-xs text-text-primary font-normal font-sans text-wrap">
                              {errorStrip || "An error occurred"}
                            </span>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ) : account.approval_status === "error" ||
                    errorStrip.length > GlobalConfiguration?.lengthCheckZero ? (
                    <div className="flex bg-negative-card">
                      <div className="flex flex-row h-full w-full bg-failed-to-take-action py-padding-md px-padding-lg">
                        <div className="flex place-items-center">
                          <img
                            src="https://q2pay.in/new_assets/common/create_flow/error_with_white_outlined_circle.svg"
                            className="functionBlockImg flex-shrink-0"
                            alt=""
                          />
                        </div>
                        <div className="flex flex-col gap-y-gap-xs ml-margin-sm">
                          <span className="text-font-sm text-text-primary font-sans font-semibold">
                            Failed to take action
                          </span>
                          <Tooltip
                            componentsProps={{
                              popper: {
                                sx: {
                                  [`& .${tooltipClasses.tooltip}`]: {
                                    backgroundColor: (theme) =>
                                      theme.palette.common.black,
                                  },
                                  [`& .${tooltipClasses.arrow}`]: {
                                    color: (theme) =>
                                      theme.palette.common.black,
                                  },
                                },
                              },
                            }}
                            title={account?.error_msg || "An error occurred"}
                            arrow
                            placement="bottom"
                            PopperProps={{ style: { maxWidth: "none" } }}
                          >
                            <span className="text-font-xs text-text-primary font-normal font-sans text-wrap">
                              {errorStrip || "An error occurred"}
                            </span>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ) : account.approval_status === "pending" ? (
                    <div className="flex ">
                      <div className="flex flex-row w-full">
                        <TopNavSmallButton
                          enabledBgColor={"var(--negative-act)"}
                          btnText={
                            <>
                              Reject <br /> account
                            </>
                          }
                          isDisabled={
                            !services?.some(
                              (service) =>
                                service === "IAAccount" || service === "Admin",
                            )
                          }
                          icon="https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg"
                          hoverOption={"black"}
                          fullWidthRequired={true}
                          enabledTextColor={"var(--text-primary)"}
                          handleFunction={() => {
                            if (
                              services?.find(
                                (service) =>
                                  service === "IAAccount" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              handleDeclinedDetials(
                                viewInternalAccountDetailData
                                  ?.internal_accounts[0]?.id,
                              );
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAAccount",
                                },
                              });
                            }
                          }}
                        />
                        <TopNavSmallButton
                          enabledBgColor={"var(--positive-act)"}
                          btnText={
                            <>
                              Approve <br /> account
                            </>
                          }
                          icon="https://q2pay.in/new_assets/common/approval/approve_circle_green_checkmark.svg"
                          hoverOption={"black"}
                          fullWidthRequired={true}
                          enabledTextColor={"var(--text-primary)"}
                          isDisabled={
                            !services?.some(
                              (service) =>
                                service === "IAAccount" || service === "Admin",
                            )
                          }
                          handleFunction={() => {
                            if (
                              services?.find(
                                (service) =>
                                  service === "IAAccount" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              setClickedBtn("approve");
                              handleApprovalDetails(
                                viewInternalAccountDetailData
                                  ?.internal_accounts[0]?.id,
                              );
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "IAAccount",
                                },
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
            <div className="block mt-margin-md Qlg:hidden">
              <div className="flex flex-col">
                <div className=" w-full p-padding-button-l bg-primary-card border-b border-solid border-primary-bg">
                  <p className="text-left text-font-sm text-text-secondary font-sans font-semibold">
                    Quick Actions
                  </p>
                </div>

                <div className="flex flex-row  w-full bg-primary-card border-b border-solid border-primary-bg">
                  <TopNavSmallButton
                    btnText={
                      <>
                        View linked
                        <br /> owner account
                      </>
                    }
                    icon={
                      "https://q2pay.in/new_assets/common/detail_page/linked_white_circle.svg"
                    }
                    hoverOption={"white"}
                    fullWidthRequired={true}
                    enabledBgColor={"var(--primary-nav-act)"}
                    enabledTextColor={"var(--text-primary)"}
                    disabledBgColor={"var(--primary-card)"}
                    disabledTextColor={"var(--text-primary)"}
                    handleFunction={() => {
                      if (payload.type === "bene_account_detail_modal") {
                        actionRestricted();
                      } else {
                        if (owneraccountId) {
                          navigate(
                            `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${owneraccountId}`,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VAccount",
                            },
                          });
                        }
                      }
                    }}
                    isDisabled={payload.type === "bene_account_detail_modal"}
                  />
                  <div className="border-r border-solid border-primary-bg"></div>
                  <TopNavSmallButton
                    btnText={
                      <>
                        Associated
                        <br /> accounts found
                      </>
                    }
                    icon={
                      "https://q2pay.in/new_assets/common/detail_page/associated_accounts_found.svg"
                    }
                    hoverOption={"white"}
                    fullWidthRequired={true}
                    enabledBgColor={"var(--primary-nav-act)"}
                    enabledTextColor={"var(--text-primary)"}
                    disabledBgColor={"var(--primary-card)"}
                    disabledTextColor={"var(--text-primary)"}
                    handleFunction={() => {
                      if (payload.type === "bene_account_detail_modal") {
                        actionRestricted();
                      } else {
                        openAssociatedAccountsFound();
                      }
                    }}
                    isDisabled={payload.type === "bene_account_detail_modal"}
                  />
                </div>
                <div className="flex flex-row w-full bg-primary-card border-b border-solid border-primary-bg ">
                  <TopNavSmallButton
                    btnText={
                      <>
                        Transaction
                        <br /> history
                      </>
                    }
                    icon={
                      "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg"
                    }
                    hoverOption={"white"}
                    fullWidthRequired={true}
                    enabledBgColor={"var(--primary-nav-act)"}
                    enabledTextColor={"var(--text-primary)"}
                    disabledBgColor={"var(--primary-card)"}
                    disabledTextColor={"var(--text-primary)"}
                    handleFunction={() => {
                      if (payload.type === "bene_account_detail_modal") {
                        actionRestricted();
                      } else {
                        openTransactionHistory();
                      }
                    }}
                    isDisabled={payload.type === "bene_account_detail_modal"}
                  />
                  <div className="border-r border-solid border-primary-bg"></div>
                  <TopNavSmallButton
                    btnText={
                      <>
                        Edit
                        <br /> account
                      </>
                    }
                    icon={
                      "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                    }
                    hoverOption={"white"}
                    fullWidthRequired={true}
                    enabledBgColor={"var(--primary-nav-act)"}
                    enabledTextColor={"var(--text-primary)"}
                    disabledBgColor={"var(--primary-card)"}
                    disabledTextColor={"var(--text-primary)"}
                    handleFunction={() => {
                      if (
                        viewInternalAccountDetailData?.internal_accounts[0]
                          ?.approval_status === "archived" ||
                        viewInternalAccountDetailData?.internal_accounts[0]
                          ?.approval_status === "blocked"
                      ) {
                        return;
                      }
                      if (payload.type === "bene_account_detail_modal") {
                        actionRestricted();
                      } else {
                        setEditPopUp(true);
                      }
                    }}
                    isDisabled={
                      payload.type === "bene_account_detail_modal" ||
                      viewInternalAccountDetailData?.internal_accounts[0]
                        ?.approval_status === "archived" ||
                      viewInternalAccountDetailData?.internal_accounts[0]
                        ?.approval_status === "blocked"
                    }
                  />
                </div>
              </div>
            </div>
            {viewInternalAccountDetailData?.internal_accounts[
              GlobalConfiguration.lengthCheckZero
            ]?.approval_status === "pending" && (
              <div className=" w-full bg-primary-card ">
                <div className=" w-full lg:w-max-content-width m-auto">
                  {" "}
                  <CommonAlertsStrip alerts={buildAlerts()} />
                </div>
              </div>
            )}
            <div
              className={`flex-grow w-full bg-primary-bg secondaryDetailsblock ${
                payload.type === "bene_account_detail_modal"
                  ? "pb-padding-xl"
                  : editPopUp
                    ? ""
                    : "pb-padding-md"
              }`}
            >
              <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto">
                <div className="detail-category-button w-full flex Qmd:pt-padding-md pb-padding-md lg:mx-auto ml-margin-md mt-margin-md Qsmd:mt-margin-base">
                  <SwitcherTabs
                    initialActiveTab="details"
                    tabs={[
                      {
                        label: "Details",
                        key: "details",
                        handler: toggleDetails,
                      },
                      {
                        label: "Labels",
                        key: "labels",
                        handler: toggleLabelDetails,
                      },
                      {
                        label: "Recipients",
                        key: "recipients",
                        handler: toggleAdditionalRecipicent,
                      },
                    ]}
                    setIndex={setIndex}
                  />
                </div>
                <div className="relative overflow-hidden px-padding-md lg:px-padding-base">
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      <div className="flex flex-col gap-y-gap-md justify-evenly Qlg:flex-row  Qlg:gap-x-gap-md">
                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Contact Details"
                          entries={[
                            {
                              heading: "Contact number",
                              content:
                                "+91" +
                                " " +
                                viewInternalAccountDetailData
                                  ?.internal_accounts[0]?.contact_no,
                              type: "text",
                            },
                            {
                              heading: "Email ID",
                              content:
                                viewInternalAccountDetailData?.internal_accounts[0]?.email_id?.toLowerCase(),
                              type: "text",
                            },
                          ]}
                        />
                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Account Details"
                          entries={[
                            {
                              heading: "PAN number",
                              content:
                                viewInternalAccountDetailData
                                  ?.internal_accounts[0]?.pan_no,
                              type: "text",
                              onClick: viewInternalAccountDetailData
                                ?.internal_accounts[0]?.pan_no
                                ? () => {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "VPAN" ||
                                          service === "Admin",
                                      ) !== undefined &&
                                      viewInternalAccountDetailData
                                        ?.internal_accounts[0]?.pan_no
                                    ) {
                                      if (
                                        payload.type ===
                                        "bene_account_detail_modal"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        setPanShowPopup(true);
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "VPAN",
                                        },
                                      });
                                    }
                                  }
                                : undefined,
                              isDisabled:
                                payload.type === "bene_account_detail_modal",
                            },
                            {
                              isDisabled:
                                payload.type === "bene_account_detail_modal",
                              heading: "GST number",
                              content: viewInternalAccountDetailData
                                ?.internal_accounts[0]?.gstin_detail
                                ? viewInternalAccountDetailData
                                    ?.internal_accounts[0]?.gstin_detail
                                : "Not Given",
                              type: "text",
                              onClick: viewInternalAccountDetailData
                                ?.internal_accounts[0]?.gstin_detail
                                ? () => {
                                    if (
                                      payload.type ===
                                      "bene_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "VGSTIN" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        setGstShowPopup(true);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VGSTIN",
                                          },
                                        });
                                      }
                                    }
                                  }
                                : undefined,
                              isDisabled:
                                payload.type === "bene_account_detail_modal",
                            },
                          ]}
                        />
                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Origin Details"
                          entries={approvalEntry}
                        />

                        <CommonDetailCard
                          variant="fourth"
                          numCols={GlobalConfiguration?.lengthCheckOne}
                          cardTitle="Support Information"
                          entries={[
                            {
                              heading: "Account ID",
                              content:
                                viewInternalAccountDetailData
                                  ?.internal_accounts[0]?.id,
                              type: "text",
                            },
                            {
                              heading: "Account type",
                              content: "Internal account",
                              type: "text",
                            },
                          ]}
                        />
                      </div>
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header="Assigned Labels"
                        subheader="Labels will be used to generate statistics for the
                      associated accounts."
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (payload.type === "bene_account_detail_modal") {
                            actionRestricted();
                          } else {
                            handleClick();
                          }
                        }}
                        icon={
                          "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                        }
                        iconIsDisabled={
                          isArchived ||
                          payload?.type === "bene_account_detail_modal"
                        }
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(labelDetails) &&
                          labelDetails.length >
                            GlobalConfiguration?.lengthCheckZero ? (
                            <>
                              {labelDetails.map((item, index) => (
                                <Box
                                  key={index}
                                  className="px-padding-button-l py-padding-button-m flex rounded-border-radius-md bg-primary-nav max-w-full"
                                >
                                  <div className="text-text-primary text-font-xs inline-block truncate">
                                    {item}
                                  </div>
                                </Box>
                              ))}
                            </>
                          ) : (
                            <p className="text-font-sm text-text-primary">
                              No labels assigned.
                            </p>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}
                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      <CommonContainerCard
                        header={TEXT.ADDITIONAL_RECIPIENTS}
                        subheader=" The email IDs provided below will be used to send updates
                      and notifications to the selected individuals."
                        handleFunction={(e) => {
                          e.stopPropagation();
                          if (payload?.type === "bene_account_detail_modal") {
                            actionRestricted();
                            return;
                          } else if (
                            isArchived ||
                            isBlocked ||
                            !services?.find(
                              (service) => service === "IUAccount",
                            )
                          ) {
                            return;
                          } else {
                            setShowAdditionalSection(true);
                            setAdditionalChip(showAdditionalRecipient);
                          }
                        }}
                        icon={
                          "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                        }
                        iconIsDisabled={
                          isArchived ||
                          isBlocked ||
                          !services?.find(
                            (service) => service === "IUAccount",
                          ) ||
                          payload?.type === "bene_account_detail_modal"
                        }
                      >
                        <div className="flex flex-wrap w-full gap-gap-sm">
                          {Array.isArray(showAdditionalRecipient) &&
                          showAdditionalRecipient.length >
                            GlobalConfiguration?.lengthCheckZero ? (
                            <>
                              {showAdditionalRecipient.map((item, index) => (
                                <Box
                                  key={index}
                                  className="px-padding-button-l py-padding-button-m flex rounded-border-radius-md bg-primary-nav max-w-full"
                                >
                                  <div className="text-text-primary text-font-xs inline-block truncate">
                                    {linkIdentifier(item)}
                                  </div>
                                </Box>
                              ))}
                            </>
                          ) : (
                            <h1 className="text-text-primary text-sm">
                              No recipients assigned.
                            </h1>
                          )}
                        </div>
                      </CommonContainerCard>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InternalAccDetail;
